import { FlowRouteSeoData } from '@apiShared/seo/flow-route-seo.types';

/** Textos SEO para el flujo de apertura (formulario v2, alertas y magical experience). */
export const flowRouteSeo = {
  PortalModule: {
    title: 'Tus inversiones — MejorCDT',
    description:
      'Administra tus Certificados de Depósito a Término (CDTs) en línea con MejorCDT. Consulta, renueva y administra tus CDTs de forma sencilla y segura.',
    articleSection: 'Portal de inversiones',
  },
  datosPersonales: {
    title: 'Datos personales — Abre tu CDT en línea | MejorCDT',
    description:
      'Completa tus datos personales para seguir abriendo tu Certificado de Depósito a Término (CDT) de forma digital, segura y guiada con MejorCDT.',
    articleSection: 'Formulario de apertura de CDT',
  },
  datosFinancieros: {
    title: 'Datos financieros — Abre tu CDT en línea | MejorCDT',
    description:
      'Registra tu información financiera para continuar con la apertura de tu CDT en el banco que elegiste. Proceso en línea con MejorCDT.',
    articleSection: 'Formulario de apertura de CDT',
  },
  preguntasBan100: {
    title: 'Preguntas de validación Ban100 — Abre tu CDT | MejorCDT',
    description:
      'Responde las preguntas de seguridad del banco para validar tu identidad y avanzar en la apertura de tu CDT con MejorCDT.',
    articleSection: 'Validación con el banco',
  },
  preguntasBancamia: {
    title: 'Preguntas de validación Bancamía — Abre tu CDT | MejorCDT',
    description:
      'Completa la validación de identidad con Bancamía para continuar con tu proceso de apertura de CDT de forma segura.',
    articleSection: 'Validación con el banco',
  },
  preguntasBancow: {
    title: 'Preguntas de validación Banco W — Abre tu CDT | MejorCDT',
    description:
      'Responde las preguntas de seguridad de Banco W para verificar tu identidad y seguir con la apertura de tu CDT.',
    articleSection: 'Validación con el banco',
  },
  preguntasColtefinanciera: {
    title: 'Preguntas de validación Coltefinanciera — Abre tu CDT | MejorCDT',
    description:
      'Valida tu identidad con Coltefinanciera respondiendo sus preguntas de seguridad y avanza en tu CDT con MejorCDT.',
    articleSection: 'Validación con el banco',
  },
  preguntasIris: {
    title: 'Preguntas de validación Iris — Abre tu CDT | MejorCDT',
    description: 'Completa las preguntas de validación de Iris para continuar con la apertura de tu CDT en línea.',
    articleSection: 'Validación con el banco',
  },
  preguntasFlamingo: {
    title: 'Preguntas Flamingo — Abre tu CDT con Coltefinanciera | MejorCDT',
    description:
      'Responde las preguntas del flujo Flamingo de Coltefinanciera para validar tu identidad y seguir con tu CDT.',
    articleSection: 'Validación con el banco',
  },
  preguntasMibanco: {
    title: 'Preguntas de validación Mi Banco — Abre tu CDT | MejorCDT',
    description:
      'Completa la validación de identidad con Mi Banco y continúa la apertura de tu Certificado de Depósito a Término.',
    articleSection: 'Validación con el banco',
  },
  preguntasMundoMujer: {
    title: 'Preguntas de validación Banco Mundo Mujer — Abre tu CDT | MejorCDT',
    description:
      'Responde las preguntas de seguridad de Banco Mundo Mujer para verificar tu identidad y avanzar en tu CDT.',
    articleSection: 'Validación con el banco',
  },
  preguntasCredifamilia: {
    title: 'Preguntas de validación Credifamilia — Abre tu CDT | MejorCDT',
    description:
      'Valida tu identidad con Credifamilia mediante sus preguntas de seguridad y sigue con la apertura de tu CDT.',
    articleSection: 'Validación con el banco',
  },
  preguntasCdturbo: {
    title: 'Preguntas de validación CDTurbo — Abre tu CDT | MejorCDT',
    description:
      'Completa la validación con CDTurbo para continuar de forma segura con la apertura de tu Certificado de Depósito a Término.',
    articleSection: 'Validación con el banco',
  },
  preguntasKoa: {
    title: 'Preguntas de validación Koa — Abre tu CDT | MejorCDT',
    description:
      'Responde las preguntas de validación de Koa para confirmar tu identidad y avanzar en tu proceso de CDT con MejorCDT.',
    articleSection: 'Validación con el banco',
  },
  preguntasBancounion: {
    title: 'Preguntas de validación Banco Unión — Abre tu CDT | MejorCDT',
    description:
      'Completa las preguntas de seguridad de Banco Unión para validar tu identidad y seguir abriendo tu CDT en línea.',
    articleSection: 'Validación con el banco',
  },
  noPodemosContinuar: {
    title: 'No podemos continuar con tu proceso — MejorCDT',
    description:
      'Información sobre el estado de tu solicitud de CDT. Conoce los siguientes pasos o alternativas desde MejorCDT.',
    articleSection: 'Estado del proceso de CDT',
  },
  firmaDocumentosFisico: {
    title: 'Firma de documentos en físico — MejorCDT',
    description:
      'Te indicamos qué hacer cuando tu banco requiere firma física de documentos para completar la apertura de tu CDT.',
    articleSection: 'Estado del proceso de CDT',
  },
  bloqueoTemporal: {
    title: 'Bloqueo temporal — MejorCDT',
    description:
      'Tu proceso presenta un bloqueo temporal. Revisa la información mostrada en pantalla y las opciones para continuar con MejorCDT.',
    articleSection: 'Estado del proceso de CDT',
  },
  teContactaremos: {
    title: 'Te contactaremos — MejorCDT',
    description:
      'Hemos registrado tu caso y nos pondremos en contacto contigo. Mientras tanto, puedes revisar el estado de tu proceso en MejorCDT.',
    articleSection: 'Estado del proceso de CDT',
  },
  confirmaTusDatos: {
    title: 'Confirma tus datos — Abre tu CDT | MejorCDT',
    description:
      'Revisa y confirma que tus datos son correctos antes de continuar con la validación y la apertura de tu CDT.',
    articleSection: 'Apertura de CDT',
  },
  bienvenidaUsuarioRetorno: {
    title: 'Bienvenida de vuelta — Continúa tu CDT | MejorCDT',
    description: 'Retoma tu proceso de apertura de CDT donde lo dejaste. Accede de forma segura con MejorCDT.',
    articleSection: 'Apertura de CDT',
  },
  validarIdentidad: {
    title: 'Validar identidad — Abre tu CDT | MejorCDT',
    description:
      'Completa el paso de validación de identidad para seguir con la apertura de tu Certificado de Depósito a Término.',
    articleSection: 'Apertura de CDT',
  },
  confirmarDatosTruora: {
    title: 'Confirmar datos — Validación Truora | MejorCDT',
    description:
      'Confirma la información de tu validación de identidad y avanza en el proceso de apertura de tu CDT con MejorCDT.',
    articleSection: 'Apertura de CDT',
  },
  continuarProceso: {
    title: 'Continuar proceso — Abre tu CDT | MejorCDT',
    description: 'Sigue los pasos indicados para continuar con la apertura de tu CDT de manera guiada y segura.',
    articleSection: 'Apertura de CDT',
  },
  consultaEnListas: {
    title: 'Consulta en listas — Abre tu CDT | MejorCDT',
    description:
      'Estamos verificando la información requerida para tu proceso de CDT. Conoce el estado de esta revisión en MejorCDT.',
    articleSection: 'Cumplimiento y validaciones',
  },
  subeTusDocumentos: {
    title: 'Sube tus documentos — Abre tu CDT | MejorCDT',
    description:
      'Adjunta los documentos solicitados por el banco para completar tu solicitud de apertura de CDT de forma digital.',
    articleSection: 'Apertura de CDT',
  },
  aseguraTuTasa: {
    title: 'Asegura tu tasa — Abre tu CDT | MejorCDT',
    description: 'Formaliza y asegura la tasa de tu CDT según lo acordado con el banco. Sigue los pasos en MejorCDT.',
    articleSection: 'Apertura de CDT',
  },
  transfiereElDinero: {
    title: 'Transfiere el dinero — Abre tu CDT | MejorCDT',
    description:
      'Realiza la transferencia para fondear tu CDT. Te guiamos con las opciones disponibles (PSE y más) de forma segura.',
    articleSection: 'Apertura de CDT',
  },
  cdtCompletado: {
    title: 'CDT completado — Felicitaciones | MejorCDT',
    description:
      'Has finalizado el proceso de apertura de tu Certificado de Depósito a Término. Revisa los detalles y próximos pasos en MejorCDT.',
    articleSection: 'Apertura de CDT',
  },
  cuentanosSobreTi: {
    title: 'Cuéntanos sobre ti — Experiencia MejorCDT',
    description:
      'Comparte tus datos para personalizar tu experiencia y abrir tu CDT con el acompañamiento de MejorCDT.',
    articleSection: 'Experiencia guiada CDT',
  },
} as const satisfies Record<string, FlowRouteSeoData>;
